import * as React from 'react';

import { Profile } from 'components';
import { Size } from 'types';
import { TEXT } from 'texts';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import { useTranslation } from 'react-i18next';
import { Description } from "../Description";

type RecipientProps = {
  size?: Size;
};

const Recipient: React.FC<RecipientProps> = ({ size }) => {
  const { t } = useTranslation();
  const { dataStore } = useStores();
  return (
    dataStore.appData && (
      <>
        <Profile size={size} name={dataStore.appData.recipient.name} subtitle={t(TEXT.recipient)} hasParticipant={dataStore.hasParticipants}/>
        <Description/>
      </>
    )
  );
};

export default observer(Recipient);
